import useApi from '../../components/js/Composables/useApi'
import type { DocumentSign, DocumentSigner } from '../../Types/document'

export function useDocumentSignApi() {
  const { getJSON, postJSON, deleteJSON } = useApi()

  async function create({ contractId }: { contractId: number }): Promise<DocumentSign> {
    return await postJSON(`contracts/${contractId}/document-signs`, {})
  }

  async function fetchContractDocumentSign({ contractId }: { contractId: number }): Promise<DocumentSign | null> {
    return await getJSON(`contracts/${contractId}/contract-document-sign`)
  }

  async function createContractDocumentSign({ contractId }: { contractId: number }): Promise<DocumentSign | null> {
    return await postJSON(`contracts/${contractId}/contract-document-sign`, {})
  }

  async function deleteDocumentSign(documentSignId: number): Promise<void> {
    await deleteJSON(`document-signs/${documentSignId}`)
  }

  async function cancel(documentSignId: number): Promise<DocumentSign> {
    return await postJSON(`document-signs/${documentSignId}/cancel?replace=true`)
  }

  async function getSigners(documentSignId: number): Promise<DocumentSigner[]> {
    return await getJSON(`document-signs/${documentSignId}/signers`)
  }

  async function deleteDocument(documentSignId: number, documentSignFileId: number): Promise<void> {
    await deleteJSON(`document-signs/${documentSignId}/document-sign-file/${documentSignFileId}`)
  }

  async function deleteDocumentSignFollower(documentSignId: number, documentSignFollowerId: number): Promise<void> {
    await deleteJSON(`document-signs/${documentSignId}/followers/${documentSignFollowerId}`)
  }

  return {
    // Methods
    create,
    fetchContractDocumentSign,
    createContractDocumentSign,
    deleteDocumentSign,
    cancel,
    getSigners,
    deleteDocument,
    deleteDocumentSignFollower,
  }
}
